export class LanguageModel {
    name: string;
    id: any;
    apiModel?: string;

    constructor(id: string, name?: string, apiModel?: string) {
        this.id = id;

        if (!name) {
            this.name = this.getLocalizationToken();
        }

        this.apiModel = apiModel;
    }

    private getLocalizationToken(): string {
        return 'Language.' + this.id;
    }
}
